import { useCallback, useEffect, useRef, useState } from 'react';

import { getTenants, type TenantsPage } from '../api/tenants.api';
import { mapTenantToTable } from '../mappers/tenant.mapper';

import type { TenantTableRow } from '../types/tenant.types';


export function useTenants(page = 1, pageSize = 20, search = '') {

  const [tenants, setTenants] = useState<TenantTableRow[]>([]);
  const [meta, setMeta] = useState<TenantsPage['meta']>({ page, limit: pageSize, total: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);


  const loadTenants = useCallback(() => {

    setLoading(true);
    setError(null);

    return getTenants(page, pageSize, search)
      .then((data) => {

        if (!mountedRef.current) return;

        setTenants(
          data.tenants.map(mapTenantToTable)
        );
        setMeta(data.meta);

      })
      .catch(() => {

        if (mountedRef.current) {
          setError(
            'خطا در دریافت لیست مستاجرها'
          );
        }

      })
      .finally(() => {

        if (mountedRef.current) {
          setLoading(false);
        }

      });

  }, [page, pageSize, search]);


  useEffect(() => {

    mountedRef.current = true;

    loadTenants();

    return () => {
      mountedRef.current = false;
    };

  }, [loadTenants]);


  return {
    tenants,
    meta,
    loading,
    error,
    refetch: loadTenants,
  };
}
